import { useMutation } from '@tanstack/react-query';

const useCheckArbitrageProposalStatus = () => {
  const mutation = useMutation({
    mutationFn: async (arbitrageId: string) => {
      const token = sessionStorage.getItem('authToken');
      const response = await fetch(`${import.meta.env.VITE_API_BASE_URL}/api/arbitrages/${arbitrageId}`, {
        headers: {
          'content-type': 'application/json',
          'x-forwarded-authorization': `Bearer ${import.meta.env.VITE_API_X_FORWARDED_AUTHORIZATION}`,
          ...(token ? { 'x-customer-header': `Bearer ${token}` } : {}),
          'x-client-type': 'mobile',
        },
      });
      // 410 « arbitrage expiré » (et tout autre code non-2xx) : proposition non consultable.
      if (!response.ok) throw new Error(String(response.status));
    },
  });

  const checkProposalStatus = (arbitrageId: string | null | undefined, onValid: () => void) => {
    if (!arbitrageId || mutation.isPending) return;
    mutation.mutate(arbitrageId, { onSuccess: () => onValid() });
  };

  return {
    showExpiredModal: mutation.isError,
    checkProposalStatus,
    closeExpiredModal: mutation.reset,
    isPending: mutation.isPending,
  };
};

export default useCheckArbitrageProposalStatus;
